import React from "react";
import { Grid, Box } from "@mui/material";
import { ModernLiquidTable } from "../../../components/modern-table";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { getExpiredMembers } from "../../../api/member";

export default function MemberExpired(props) {
  const [expired, setExpired] = React.useState([]);
  const [alumni, setAlumni] = React.useState([]);
  const [msg, setMsg] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = await getExpiredMembers();
      if (data) {
        if (data.message) {
          setMsg("Tiada Ahli yang tamat keahlian hari ini");
        }
        setExpired(data.expired || []);
        setAlumni(data.alumni || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 50,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    { field: "fullname", title: "Nama", width: 250 },
    { field: "email", title: "Emel", width: 250 },
    { field: "endDate", title: "Tarikh Tamat", width: 250 },
  ];

  return (
    <>
      {msg ? (
        <Box
          sx={{
            textAlign: "center",
            p: 4,
            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
            borderRadius: '12px',
            backdropFilter: 'blur(10px)',
          }}
        >
          <h3>{msg}</h3>
        </Box>
      ) : (
        <>
          {[
            { data: alumni, title: "Bilangan Ahli Alumni", description: "Senarai ahli yang telah menjadi alumni untuk hari ini.", emptyMsg: "Tiada ahli alumni hari ini" },
            { data: expired, title: "Bilangan Ahli Tamat Tempoh", description: "Senarai ahli yang telah tamat keahlian untuk hari ini.", emptyMsg: "Tiada ahli tamat tempoh hari ini" }
          ].map((table, index) => (
            <Portlet key={index} style={{ marginBottom: '24px' }}>
              <PortletBody fluid={true}>
                <Grid className="p-3" container spacing={3}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        mb: 2,
                        p: 2,
                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                        borderRadius: '12px',
                        backdropFilter: 'blur(10px)',
                      }}
                    >
                      <span className="kt-section__sub">{table.description}</span>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <ModernLiquidTable
                      columns={columns}
                      data={table.data}
                      title={`${table.title}: ${table.data.length}`}
                      loading={loading}
                      onRefresh={fetchData}
                      emptyStateMessage={table.emptyMsg}
                      options={{
                        selection: false,
                        pageSize: 10,
                        pageSizeOptions: [5, 10, 20, 50],
                      }}
                    />
                  </Grid>
                </Grid>
              </PortletBody>
            </Portlet>
          ))}
        </>
      )}
    </>
  );
}
